import React from 'react';
import { useHistory } from 'react-router-dom';
import pregnantImage from 'assets/LandingPage/6.png';
import pregnantIcon from 'assets/icon/icone-1.png'
import pregnantImage2 from 'assets/LandingPage/7.png';
import pregnantImage3 from 'assets/LandingPage/8.png';
import pregnantImage4 from 'assets/LandingPage/9.png';
import heart from 'assets/icon/icone.png'

import {
  Wrapper,
  Container,
  HeaderSection,
  Title,
  Highlight,
  Subtitle,
  StatsGrid,
  StatCard,
  StatIconCard,
  StatNumber,
  StatLabel,
  StatImage,
  GalleryGrid,
  LargeImage,
  GradientCard,
  TextCardContent,
  CtaSection,
  PrimaryButton,
  FreeText,

  TopRow,
  SmallImage,
  TextCard,
  BottomRow,
  StatImageGrid,
  TextCardContentBottom,
} from './style';

export default function HighlightsGallery() {
  const history = useHistory();
  return (
    <Wrapper>
      <Container>
        <HeaderSection>
          <Title>
            <Highlight>Juntas</Highlight>, somos mais fortes
          </Title>
          <Subtitle>
            Participe de uma verdadeira comunidade formada por mulheres como você!
          </Subtitle>
        </HeaderSection>

        <StatsGrid>
          <StatCard>
            <StatIconCard>
              <img src={pregnantIcon} alt="Ícone de gestante" />
            </StatIconCard>
            <StatNumber>+ de 500</StatNumber>
            <StatLabel>gestantes inscritas</StatLabel>
          </StatCard>

          <StatCard>
            <StatIconCard>
              <img src={heart} alt="Ícone de coração" />
            </StatIconCard>
            <StatNumber>Recomendado</StatNumber>
            <StatLabel>por profissionais da saúde</StatLabel>
          </StatCard>

         
          <StatImageGrid src={pregnantImage} alt="Gestante" />
    
        </StatsGrid>

        <GalleryGrid>
          <LargeImage>
            <StatImage src={pregnantImage2} alt="Gestante" />
          </LargeImage>
          
          <TopRow>
            <SmallImage>
              <StatImage src={pregnantImage3} alt="Gestante" />
            </SmallImage>
            <TextCard>
              <TextCardContent>
                Saúde, bem-estar e dicas práticas para lidar com a nova realidade que está nascendo
              </TextCardContent>
            </TextCard>
          </TopRow>

          <BottomRow>
            <GradientCard>
              <TextCardContentBottom>Trocas de experiências com quem está vivendo as mesmas emoções</TextCardContentBottom>
            </GradientCard>
            <SmallImage>
              <StatImage src={pregnantImage4} alt="Gestante" />
            </SmallImage>
          </BottomRow>
        </GalleryGrid>

        <CtaSection>
          <p>Faça parte da nossa comunidade de mamães preparadas</p>
          <PrimaryButton style={{margin: "10px"}} onClick={() => history.push('/signup')}>Inscreva-se Agora →</PrimaryButton>
          <FreeText>100% online e gratuito</FreeText>
        </CtaSection>
      </Container>
    </Wrapper>
  );
}
